var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-tooltip", {
    style: _vm.styleObject,
    attrs: {
      id: "tooltip",
      type: "is-black",
      position: _vm.position,
      label: _vm.content,
      always: _vm.isVisible
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }